<mat-card>
    <mat-card-content>
  <div class="centered">
  <table id="members">
    <tr>
      <th>User ID</th>
      <th>Role</th>
      <th>Power User?</th>
    </tr>
    @for (group of userGroups; track group.get('user_id')!.value ) {
      <tr [formGroup]="group">
        <td>{{group.get('user_id')!.value}}</td>
        <td>
          @if( group.get('user_id')!.value !== user_id ) {
           <mat-select formControlName="user_role" class="wider">
              @for (role of projectRoles; track role) {
                <mat-option [value]="role">{{role}}</mat-option>
              }
            </mat-select>
          }
            @if( group.get('user_id')!.value === user_id ) {
              <span>{{group.get('user_role')!.value}}</span>
            }
        </td>
        <td>
          <mat-slide-toggle formControlName="power_user">Power User</mat-slide-toggle>
      </tr>
    }
  </table>
</div>
  
  <div id="add-member">
    <button mat-stroked-button color="secondary" (click)="newMember()" type="button">Add a new member...</button>
  </div>

    </mat-card-content>
  </mat-card>
